import CustomSwitchDetailCard from './CustomSwitchDetailCard'

export default CustomSwitchDetailCard
